<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container "
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%;"
            >
              <div class="col-12 p-6">
                <h4>{{ $t("sidebar.accounts.accounts") }}</h4>
              </div>
              <table
                class="dt-scrollableTable table datatables-basic dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="accounts_table"
                aria-describedby="DataTables_Table_0_info"
                style="width: 1653px;"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("accounts.first_name") }}</th>
                    <th>{{ $t("accounts.last_name") }}</th>
                    <th>{{ $t("accounts.username") }}</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 3" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(account, index) in accounts" :key="index">
                    <td>{{ account.id }}</td>
                    <td>{{ account.first_name }}</td>
                    <td>{{ account.last_name }}</td>
                    <td>
                      <a
                        class="btn btn-link"
                        :href="`accounts/${account.id}`"
                        @click.prevent="$router.push(`/accounts/${account.id}`)"
                        >{{ account.username }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 p-6">
                <h4>{{ $t("sidebar.cards.cards") }}</h4>
              </div>
              <table
                class="dt-scrollableTable table datatables-basic dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="cards_table"
                aria-describedby="DataTables_Table_0_info"
                style="width: 1653px;"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("cards.username") }}</th>
                    <th>{{ $t("cards.password") }}</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 3" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(card, index) in cards" :key="index">
                    <td>{{ card.id }}</td>
                    <td>
                      <a
                        class="btn btn-link"
                        :href="`cards?username${card.username}`"
                        @click.prevent="
                          $router.push(`/cards?username=${card.username}`)
                        "
                        >{{ card.username }}</a
                      >
                    </td>
                    <td>{{ card.password }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Search",
  data() {
    return {
      accounts: [],
      cards: [],
      loading: false,
    };
  },
  created() {
    this.fetchSearch();
  },
  watch: {
    $route(newRoute, lastRoute) {
      this.fetchSearch();
    },
  },
  methods: {
    async fetchSearch() {
      this.loading = true;
      const response = await axios.get(
        `globalsearch?search_query=${this.$route.query.query}`
      );
      if (response.status == 200) {
        this.accounts = response.data.data.accounts;
        this.cards = response.data.data.cards;
      }
      this.loading = false;
    },
  },
};
</script>
